// extracted by mini-css-extract-plugin
export default {"menuItemSpacer":"f8TPDPgZWBeJco6A3VCt+Q=="};